var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFace1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15313 5.30191C2.22915 7.83946 1.47725 11.163 1.07918 14.3967C0.747462 17.1138 0.636889 19.9209 1.43302 22.5258C2.6051 26.3658 5.70116 29.3075 9.2174 30.7447C12.7336 32.1819 16.6258 32.2493 20.3411 31.6205C26.9534 30.5202 32.4379 24.21 32.7917 16.9791C33.3446 6.37981 23.592 -1.07563 14.348 0.137001C10.5222 0.631036 6.56363 2.09069 4.15313 5.30191Z",
    fill: "#FBE250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0014 5.16618C24.763 2.38162 20.4727 1.25881 17.8853 1.68548C17.4872 1.75285 17.642 2.33671 17.9737 2.38162C19.4996 2.58373 20.8486 2.87566 22.2419 3.61671C23.3918 4.22303 24.2101 5.27846 25.3379 5.88478C25.8023 6.1318 26.2225 5.63776 26.0014 5.16618Z",
    fill: "#FFE175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0425 6.60443C26.7108 6.55952 26.556 7.05355 26.7772 7.27812C27.2195 7.72724 27.7281 8.08654 28.1262 8.60303C28.5463 9.16443 28.7896 9.83812 29.2098 10.3995C29.4752 10.7588 29.9617 10.4444 29.9838 10.0627C30.0944 8.49075 28.4137 6.76162 27.0204 6.60443H27.0425Z",
    fill: "#FFE175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5125 11.3829C12.4462 10.9114 11.7827 10.9114 11.5837 11.2482C10.9866 12.2812 10.7876 13.1345 9.48281 13.4714C7.979 13.8756 6.85115 12.3935 6.65212 11.0685C6.60789 10.7542 6.14348 10.844 6.12137 11.1359C6.03291 12.7528 7.35979 14.4594 9.0184 14.5492C10.6549 14.6391 12.8 13.2468 12.5125 11.3829Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73038 16.2347C8.13328 16.0102 5.78912 20.479 8.19962 20.6362C10.588 20.7933 10.1236 16.7962 8.73038 16.2347Z",
    fill: "#83D0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68772 22.2101C8.24543 22.0304 6.47625 25.3988 8.28966 25.5111C10.081 25.6234 9.74923 22.6143 8.68772 22.2101Z",
    fill: "#83D0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9207 11.3829C19.987 10.9114 20.6504 10.9114 20.8495 11.2482C21.4466 12.2812 21.6456 13.1345 22.9504 13.4714C24.4542 13.8756 25.582 12.3935 25.7811 11.0685C25.8253 10.7542 26.2897 10.844 26.3118 11.1359C26.4003 12.7528 25.0734 14.4594 23.4148 14.5492C21.7783 14.6391 19.6332 13.2468 19.9207 11.3829Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7036 16.2347C24.3007 16.0102 26.6449 20.479 24.2344 20.6362C21.846 20.7933 22.3104 16.7962 23.7036 16.2347Z",
    fill: "#83D0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7693 22.2101C24.2116 22.0304 25.9808 25.3988 24.1674 25.5111C22.3761 25.6234 22.7078 22.6143 23.7693 22.2101Z",
    fill: "#83D0D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.988 21.604C19.5015 20.5036 17.9534 20.1668 16.8919 20.0994C15.7862 20.032 14.4814 20.571 13.8622 21.5141C13.7516 21.6713 13.9286 21.9408 14.1276 21.8734C15.0785 21.5141 15.8525 21.1324 16.8919 21.1324C17.9534 21.1324 18.6169 21.8959 19.5457 22.1878C19.8995 22.3001 20.1207 21.8959 19.988 21.604Z",
    fill: "#25368D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFace1);
export default __webpack_public_path__ + "static/media/icon-face-1.d1dbb1ccfc77d9276cf3303540742c5b.svg";
export { ForwardRef as ReactComponent };